


































































































































import { Component, Vue, Mixins } from 'vue-property-decorator'
import { getLicenseUploadInfo, uploadLicense } from '@/apps/open/services/upload'
import { PROTOCOL_URL, USER_CENTER_URL } from '@/apps/open/constants'
import { applyDeveloper, getRemarkInfo } from '@/apps/open/services/developer'
import Button from '@/apps/open/components/Button'
import VerifyPhoneMixin from '@/apps/open/mixins/VerifyPhone'
import { EVerifyPhoneAction } from '@/apps/open/types'
import store from '@/apps/open/store'
import { IUserInfo, EDeveloperStatus } from '@/apps/open/store/modules/user/types'

declare global {
  interface Window {
    fetch: (url: string, options?: {}) => Promise<any>,
    AbortController: Function,
    AbortSignal: Function,
    $$DEPLOY_OPENDOC: String,
    $$DEPLOY_YUNDOC: String
  }
}

@Component({
  data: () => ({
    USER_CENTER_URL
  }),
  components: {
    Button
  }
})
export default class ApplyDeveloper extends Mixins(VerifyPhoneMixin) {
  // info: Developer = { ...this.userInfo.developer}

  info = {
    developer_id: '',
    open_ssid: '',
    developer_name: '',
    website: '',
    business_license: '',
    contacts: '',
    phone: this.userInfo.phone,
    email: '',
    trade: '',
    scale: '',
    channel: '',
    application: [] as any,
    the_others: '',
    otherChanel: '',
    otherApplication: '',
    otherthe_others: ''
  }

  reqControllers: AbortController[] = []

  submitting = false

  websiteCheckTimer: number | null = null

  checkWebsiteDebounce (rule:any, value: string, callback: Function) {
    // filter some browser that don't support check
    if (!/^(https:\/\/)/.test(value) ||
      typeof window.fetch !== 'function' ||
      typeof window.AbortController !== 'function' ||
      typeof window.AbortSignal !== 'function') {
      callback()
      return
    }
    if (this.websiteCheckTimer !== null) {
      this.reqControllers.forEach(reqController => {
        reqController.abort()
      })
      // clear controller after abort
      this.reqControllers = []
      clearTimeout(this.websiteCheckTimer)
    }
    this.websiteCheckTimer = setTimeout(() => {
      this.toLinkWebsite(value, callback)
    }, 300)
  }

  toLinkWebsite (value: string, callback: Function) {
    const reqController = new AbortController()
    const signal = reqController.signal
    // collect request controller for abort
    this.reqControllers.push(reqController)
    fetch(value, {
      method: 'GET',
      mode: 'no-cors',
      signal
    }).then(() => {
      callback()
    }).catch(() => {
      callback(new Error('无法访问此网站'))
    }).finally(() => {
      this.websiteCheckTimer = null
    })
  }

  get disabledSubmit () {
    return this.isPrivate ? this.submitting : (!this.isAgree || this.submitting)
  }

  beforeRouteEnter (to: any, from: any, next: Function) {
    next((vm: any) => {
      if ((vm.isPrivate && !vm.isPriDocEdit) && (!vm.curEnterprise || vm.curEnterprise.developer_type !== 1)) {
        // 私网，屏蔽平台服务商申请
        vm.$message.warning('请联系企业超管进行创建或将你添加为服务商管理员')
        next({ name: 'home' })
      }
    })
  }

  get isPrivate () {
    return this.$store.getters['isPrivate']
  }

  get isPriDocEdit () {
    return this.$store.getters['isPriDocEdit']
  }

  checkChanel = (rule:any, value:any, callback:any) => {
    if (!this.info.channel) {
      callback(new Error('请选择获知渠道'))
    }
    if (value === '其他') {
      if (!this.info.otherChanel || this.info.otherChanel === '') {
        callback(new Error('请输入获知渠道'))
      }
      if (this.info.otherChanel && this.info.otherChanel.length > 100) {
        callback(new Error('不超过100个字符'))
      }
    }
    callback()
  }

  checkApplication = (rule:any, value:any, callback:any) => {
    if (this.info.application.length === 0) {
      callback(new Error('请选择接入用途'))
    }
    if (value.includes('其他')) {
      if (!this.info.otherApplication || this.info.otherApplication === '') {
        callback(new Error('请输入接入用途'))
      }
      if (this.info.otherApplication && this.info.otherApplication.length > 100) {
        callback(new Error('不超过100个字符'))
      }
    }
    callback()
  }

  checkTheOthers = (rule:any, value:any, callback:any) => {
    if (!this.info.the_others) {
      callback(new Error('请选择是否接入过其他文档服务'))
    }
    if (value === '其他') {
      if (!this.info.otherthe_others || this.info.otherthe_others === '') {
        callback(new Error('请输入其他文档服务'))
      }
      if (this.info.otherthe_others && this.info.otherthe_others.length > 100) {
        callback(new Error('不超过100个字符'))
      }
    }
    callback()
  }

  get rules () {
    const privateRules = {
      developer_name: [
        { required: true, message: '请输入服务商全称', trigger: 'blur' },
        { min: 1, max: 30, message: '长度不超过30个字符', trigger: 'change' }
      ],
      contacts: [
        { required: true, pattern: /^[\u4e00-\u9fa5]{2,}$/, message: '请输入正确的姓名', trigger: 'blur' },
        { min: 1, max: 20, message: '长度不超过30个字符', trigger: 'change' }
      ],
      email: [
        { required: true, message: '请输入电子邮箱', trigger: 'blur' },
        { min: 1, max: 80, message: '长度不超过80个字符', trigger: 'change' },
        { type: 'email', message: '请输入正确的邮箱地址' }
      ]
    }
    return this.isPrivate ? privateRules : {
      ...privateRules,
      website: [
        { required: true, message: '请输入服务商官网', trigger: 'blur' },
        { min: 1, max: 80, message: '长度不超过80个字符', trigger: 'change' },
        { type: 'url', message: '请输入正确的官网地址' },
        { validator: this.checkWebsiteDebounce, trigger: 'change' }
      ],
      business_license: [
        { required: true, message: '请上传照片', trigger: 'change' }
      ],
      trade: [
        { required: true, message: '请选择所在行业', trigger: 'change' }
      ],
      scale: [
        { required: true, message: '请选择公司规模', trigger: 'change' }
      ],
      phone: [
        { required: true, message: '请先绑定手机号码' }
      ],
      the_others: [
        { required: true, validator: this.checkTheOthers, trigger: 'change' }
      ],
      channel: [
        { required: true, validator: this.checkChanel, trigger: 'change' }
      ],
      application: [
        { required: true, validator: this.checkApplication, trigger: 'change' }
      ]
    }
  }
  isAgree = false
  uploadPercent = 0
  uploadState = 0
  isUpdate = this.userInfo.developer && this.userInfo.developer.status === EDeveloperStatus.REJECTED

  trade = [
    { value: 'IT//互联网', label: 'IT//互联网' },
    { value: '教育/科研院校', label: '教育/科研院校' },
    { value: '法律', label: '法律' },
    { value: '办公用品及设备', label: '办公用品及设备' },
    { value: '银行/金融行业', label: '银行/金融行业' },
    { value: '政府/组织', label: '政府/组织' },
    { value: '广告/公关/媒体', label: '广告/公关/媒体' },
    { value: '传统制造业', label: '传统制造业' },
    { value: '批发零售/快消', label: '批发零售/快消' },
    { value: '餐饮娱乐/生活服务', label: '餐饮娱乐/生活服务' },
    { value: '医疗卫生', label: '医疗卫生' },
    { value: '交通/运输/物流', label: '交通/运输/物流' },
    { value: '其他', label: '其他' }
  ]

  scale = [
    { value: '20人以下', label: '20人以下' },
    { value: '20-100人', label: '20-100人' },
    { value: '100-500人', label: '100-500人' },
    { value: '500-2000人', label: '500-2000人' },
    { value: '2000人以上', label: '2000人以上' }
  ]

  file: any
  bussinessLicenseKey = ''

  get userInfo () : IUserInfo {
    return this.$store.getters['User/userInfo']
  }

  get userDevelopers () {
    return this.$store.getters['User/userInfo'].developers || []
  }

  get curEnterprise (): any {
    return this.$store.getters['User/curEnterprise']
  }

  async mounted () {
    if (this.curEnterprise) {
      this.info.developer_name = this.curEnterprise.developer_name!
      this.info.website = this.curEnterprise.website!
      this.info.business_license = this.curEnterprise.business_license!
      this.info.contacts = this.curEnterprise.contacts!
      this.info.email = this.curEnterprise.email!
      const res = await getRemarkInfo(this.curEnterprise && this.curEnterprise.developer_id)
      const remarkInfo = res.data.object
      this.info.trade = remarkInfo.trade
      this.info.scale = remarkInfo.scale
      this.info.channel = remarkInfo.channel
      if (this.info.channel.startsWith('其他')) {
        this.info.otherChanel = this.info.channel.substring(this.info.channel.indexOf(':') + 1)
        this.info.channel = '其他'
      }
      this.info.application = remarkInfo.application.split(';')
      for (let j = 0; j < this.info.application.length; j++) {
        if (this.info.application[j].startsWith('其他')) {
          this.info.otherApplication = this.info.application[j].substring(this.info.application[j].indexOf(':') + 1)
          this.info.application[j] = '其他'
        }
      }
      this.info.the_others = remarkInfo.the_others
      if (this.info.the_others.startsWith('其他')) {
        this.info.otherthe_others = this.info.the_others.substring(this.info.the_others.indexOf(':') + 1)
        this.info.the_others = '其他'
      }
    }
  }

  /**
   * 提交申请
   */
  submit () {
    let ref: any = this.$refs['info']
    ref.validate((valid: any) => {
      if (valid) {
        if (!this.isPrivate) {
          this.verifyPhone({
            action: EVerifyPhoneAction.SIGNUP_DEV,
            cb: this.onVerifyPhoneOk
          })
        } else {
          this.onVerifyPhoneOk('')
        }
      } else {
        return false
      }
    })
  }

  async uploadFile (options: any) {
    try {
      const res = await getLicenseUploadInfo()
      const { action, params } = res.data
      const formData = new FormData()
      formData.append('key', params.key)
      formData.append('KSSAccessKeyId', params.KSSAccessKeyId)
      formData.append('Signature', params.signature)
      formData.append('Policy', params.policy)
      formData.append('bucket', params.bucket)
      formData.append('acl', 'private')
      formData.append('file', this.file)
      await uploadLicense(action, formData)
      Vue.set(this.info, 'business_license', URL.createObjectURL(this.file))
      this.bussinessLicenseKey = params.key
    } catch (error) {
      this.$message.error(`上传失败，请重试（${error}）`)
    }
  }

  onBeforeUpload (file: any) {
    const isLt5M = file.size / 1024 / 1024 < 2
    if (!isLt5M) {
      this.$message.error('上传图片大小不能超过2MB')
    }
    let result = isLt5M
    if (result) {
      this.file = file
      this.uploadState = 1
    }
    return result
  }

  async handleApplyAfter () {
    // 更新用户信息
    await this.$store.dispatch('User/GET_USER_INFO')
    if (this.curEnterprise && this.curEnterprise.developer_type === 1) {
      const curDeveloper = this.userDevelopers.find((item: any) => item.company_id === this.curEnterprise.id)
      this.$store.commit('User/SET_CUR_ENTERPRISE', curDeveloper)
      this.$store.dispatch('User/SET_DEVELOPER_LIST', false)
    } else {
      const curDeveloper = this.userDevelopers.find((item: any) => item.developer_name === this.info.developer_name)
      this.$store.commit('User/SET_CUR_ENTERPRISE', curDeveloper)
      this.$store.dispatch('User/SET_DEVELOPER_LIST', false)
    }
    this.$message('申请已提交，请您耐心等待')
    this.$router.replace({ name: 'home' })
  }

  toProtocol () {
    window.open(PROTOCOL_URL)
  }

  onVerifyPhoneOk (open_ssid: string) {
    this.$dialog.close()
    this.info.open_ssid = open_ssid
    if (this.curEnterprise && this.curEnterprise.developer_id) this.info.developer_id = this.curEnterprise.developer_id
    else delete this.info.developer_id
    let developer = { ...this.info }
    developer.business_license = this.bussinessLicenseKey || developer.business_license
    if (developer.channel === '其他' && developer.otherChanel.length > 0) {
      developer.channel = developer.channel + ':' + developer.otherChanel
    }
    delete developer.otherChanel
    if (developer.the_others === '其他' && developer.otherthe_others.length > 0) {
      developer.the_others = developer.the_others + ':' + developer.otherthe_others
    }
    delete developer.otherthe_others
    let tempApplication = developer.application.join(';')
    developer.application = tempApplication.replace('其他', '其他' + ':' + developer.otherApplication)
    delete developer.otherApplication
    if (developer.open_ssid) {
      this.submitting = true
      applyDeveloper(developer)
        .then(async () => {
          await this.handleApplyAfter()
        }).catch((error: Error) => {
          this.$message.error(error.message)
        }).finally(() => {
          this.submitting = false
        })
    } else {
      let developer = { ...this.info }
      applyDeveloper(developer)
        .then(async () => {
          await this.handleApplyAfter()
        }).catch((error: Error) => {
          this.$message.error(error.message)
        }).finally(() => {
          this.submitting = false
        })
    }
  }
}
